/**
 * Health — pure value object for an entity's hit points.
 *
 * Framework-free → unit-testable. Composed into Entity (Phaser) rather than
 * inherited, so the damage/heal/clamp rules live in one tested place.
 * Green-health recovery (SoR4 style) is layered on later in MY-1438.
 */
export class Health {
  private hp: number;

  constructor(public readonly max: number) {
    this.hp = max;
  }

  get current(): number {
    return this.hp;
  }

  get isDead(): boolean {
    return this.hp <= 0;
  }

  /** 0..1 — useful for HP bars. */
  get fraction(): number {
    return this.max === 0 ? 0 : this.hp / this.max;
  }

  /** Apply damage (negatives ignored). Returns new current. */
  damage(amount: number): number {
    this.hp = Math.max(0, this.hp - Math.max(0, amount));
    return this.hp;
  }

  /** Heal (negatives ignored, capped at max). Returns new current. */
  heal(amount: number): number {
    this.hp = Math.min(this.max, this.hp + Math.max(0, amount));
    return this.hp;
  }

  reset(): void {
    this.hp = this.max;
  }
}
